import { Typography } from '@mui/material'
import type { MouseEvent, ReactNode } from 'react'
import { actorNameClickProps, projectNameClickProps } from './notificationNav'

type ActorNameSpanProps = {
  children: ReactNode
  pathKey: string
  onUserClick: (e: MouseEvent, pathKey: string) => void
}

export function ActorNameSpan({ children, pathKey, onUserClick }: ActorNameSpanProps) {
  return (
    <Typography component="span" variant="black-14-medium" {...actorNameClickProps(pathKey, onUserClick)}>
      {children}
    </Typography>
  )
}

type ProjectNameQuotedProps = {
  name: string
  /** Optional: make «name» navigate (stopPropagation via handler). */
  pathKey?: string
  onNameClick?: (e: MouseEvent, pathKey: string) => void
}

export function ProjectNameQuoted({ name, pathKey = '', onNameClick }: ProjectNameQuotedProps) {
  return (
    <Typography
      component="span"
      variant="black-14-medium"
      {...projectNameClickProps(pathKey, onNameClick)}
    >
      {`«${name}»`}
    </Typography>
  )
}
